// Admin endpoints call WebAPI directly via api.webAPIFetch (bypassing WebLayerAPI).
// markOutputReportDownloaded stays on api.transact because it's portal-facing too
// (web-referral uses it via WebLayerAPI/Services.json).

const adminFetch = async (api, route, body) => {
    try {
        const response = await api.webAPIFetch(route, {
            method: "POST",
            body: JSON.stringify(body),
        });
        if (!response.ok) {
            return {
                data: null,
                error: new Error(`HTTP ${response.status} ${response.statusText}`),
            };
        }
        const json = await response.json();
        if (json.Status !== "OK") {
            return { data: null, error: new Error(json.Text || "API error") };
        }
        return { data: json.Result, error: null };
    } catch (error) {
        return { data: null, error };
    }
};

export const searchOutputReports = (api, criteria) =>
    adminFetch(api, "/OutputReports/Search", criteria);

export const insertOutputReportTransfer = (api, model) =>
    adminFetch(api, "/OutputReports/Insert", model);

export const softDeleteOutputReport = (api, id) =>
    adminFetch(api, "/OutputReports/SoftDelete", { OutputReportTransferId: id });

export const restoreOutputReport = (api, id) =>
    adminFetch(api, "/OutputReports/Restore", { OutputReportTransferId: id });

export const extendOutputReportExpiry = (api, id, newExpiry) =>
    adminFetch(api, "/OutputReports/ExtendExpiry", {
        OutputReportTransferId: id,
        NewExpiry: newExpiry,
    });

export const markOutputReportDownloaded = async (api, id, downloaded) => {
    try {
        const response = await api.transact("MarkOutputReportDownloaded", {
            OutputReportTransferId: id,
            Downloaded: downloaded,
        });
        return { data: response.apiResult, error: null };
    } catch (error) {
        return { data: null, error };
    }
};
